import { LocationType } from '../../types/location';
import { AddressField } from './AddressModal.type';
export const ADDRESS_FIELD_MAX_LENGTHS = {
    [AddressField.ADDRESS]: 40,
    [AddressField.ADDRESS_LINE_2]: 30,
    [AddressField.CITY]: 30,
    [AddressField.NAME]: 30,
    [AddressField.COMPLEMENT]: 20,
    [AddressField.STATE]: 2,
    [AddressField.NUMBER]: 6,
};
export function formatCEP(value) {
    if (!value) {
        return '';
    }
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 5) {
        return numbers;
    }
    return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
}
export function truncateAddressField(field, value) {
    if (!value) {
        return '';
    }
    const maxLength = ADDRESS_FIELD_MAX_LENGTHS[field];
    if (maxLength === undefined) {
        return value;
    }
    return value.length > maxLength ? value.slice(0, maxLength) : value;
}
export function validateAddressField(field, data, options = {}) {
    const { currentAddress, isHiring = false } = options;
    const value = data[field];
    if (field === AddressField.COMPLEMENT ||
        (field === AddressField.LOCATION_ID && !currentAddress) ||
        (field === AddressField.DELIVERY_LOCATION_ID && !currentAddress) ||
        (field === AddressField.NAME && isHiring)) {
        return true;
    }
    if (value === undefined) {
        return false;
    }
    switch (field) {
        case AddressField.ZIP_CODE:
            return typeof value === 'string' && /^\d{8}$/.test(value.replace(/\D/g, ''));
        case AddressField.ADDRESS: {
            const maxLength = ADDRESS_FIELD_MAX_LENGTHS[AddressField.ADDRESS];
            return typeof value === 'string' && value.length > 0 && maxLength !== undefined && value.length <= maxLength;
        }
        case AddressField.NUMBER:
            if (data[AddressField.NUMBER] === 'S/N')
                return true;
            return typeof value === 'string' && /^\d{1,6}$/.test(value);
        case AddressField.COMPLEMENT: {
            const maxLength = ADDRESS_FIELD_MAX_LENGTHS[AddressField.COMPLEMENT];
            return !value || (typeof value === 'string' && maxLength !== undefined && value.length <= maxLength);
        }
        case AddressField.ADDRESS_LINE_2:
        case AddressField.CITY:
        case AddressField.NAME: {
            const maxLength = ADDRESS_FIELD_MAX_LENGTHS[field];
            return typeof value === 'string' && value.length > 0 && maxLength !== undefined && value.length <= maxLength;
        }
        case AddressField.STATE: {
            const maxLength = ADDRESS_FIELD_MAX_LENGTHS[AddressField.STATE];
            return typeof value === 'string' && value.length > 0 && maxLength !== undefined && value.length <= maxLength;
        }
        case AddressField.LOCATION_TYPE:
            return value === LocationType.COMMERCIAL || value === LocationType.RESIDENTIAL;
        default:
            return true;
    }
}
export function validateAddressForm(data, options = {}) {
    const fields = [
        AddressField.NAME,
        AddressField.ZIP_CODE,
        AddressField.ADDRESS,
        AddressField.NUMBER,
        AddressField.COMPLEMENT,
        AddressField.ADDRESS_LINE_2,
        AddressField.CITY,
        AddressField.STATE,
        AddressField.COUNTRY,
        AddressField.LOCATION_TYPE,
        AddressField.LOCATION_ID,
        AddressField.DELIVERY_LOCATION_ID,
    ];
    return fields.reduce((acc, field) => ({
        ...acc,
        [field]: validateAddressField(field, data, options),
    }), {});
}
export function isValidAddress(data, options = {}) {
    return Object.values(validateAddressForm(data, options)).every(isValid => isValid);
}
